// Enumerations
import { ProofIncomeMethodsEnumeration } from 'containers/proof-income/enumerations/proof-income-methods.enumeration';
import { ProofIncomeStatesEnumeration } from 'containers/proof-income/enumerations/proof-income-states.enumeration';
// Types
import {
  ProofIncomeLandingBuilderHandlersType,
  ProofIncomeLandingMethodBuilderHandlersType,
  ProofIncomeLandingMethodsHandlersType,
  ProofIncomeLandingMethodsOnSelectHandlersType,
} from './types/proof-income-landing.handlers.type';
// Resolvers
import { getProofIncomeMethodUrlResolver } from '../resolvers/proof-income-landing.resolver';

const manageProofIncomeMethodContinueClickHandler = async ({
  handleTrackConfirm,
  handleTrackErrorView,
  method,
  setError,
  setIframeUrl,
  setProofIncomeIdentificationId,
  setProofIncomeState,
  setSelectedMethod,
}: ProofIncomeLandingMethodBuilderHandlersType): Promise<void> => {
  handleTrackConfirm(method);
  setSelectedMethod(method);
  const [response, error] = await getProofIncomeMethodUrlResolver(method);
  if (error) {
    const [errorData, { status: errorStatus }] = response;
    setError(true);
    handleTrackErrorView({
      errorDescription: errorData.description,
      errorNumber: errorStatus,
      errorStatus: errorData.errorCode,
    });
  } else if (response) {
    response?.url && setIframeUrl(response.url);
    response?.identificationId && setProofIncomeIdentificationId(response.identificationId);
    setProofIncomeState(ProofIncomeStatesEnumeration.METHOD);
  }
};

const onSelectMethodHandler = ({
  method,
  handleTrackSelectMethod,
  setSelectedMethod,
}: ProofIncomeLandingMethodsOnSelectHandlersType): void => {
  handleTrackSelectMethod(method);
  setSelectedMethod(method);
};

const ProofIncomeLandingHandlers = (
  props: ProofIncomeLandingBuilderHandlersType
): ProofIncomeLandingMethodsHandlersType => ({
  handleManageProofIncomeMethodContinueClick: (method: ProofIncomeMethodsEnumeration) =>
    manageProofIncomeMethodContinueClickHandler({ method, ...props }),
  handleOnSelectMethod: (method: ProofIncomeMethodsEnumeration) =>
    onSelectMethodHandler({ method, ...props }),
});

export { ProofIncomeLandingHandlers };
